<!-- Main content -->
<div class="flex flex-col" *ngIf="push">
  <!-- Content -->
  <div class="flex-1">
    <!-- Included notice -->
    <div *ngIf="itemIncluded || itemMandatory" class="mb-6 mt-2 px-4 py-2 bg-theme-surface2 text-theme-primary border-l-4 border-theme-primary font-bold">
      {{itemIncluded?getString("Ingår i beställning"):getString("Obligatoriskt tillval för erbjudande")}}
    </div>

    <!-- Groups -->
    <div *ngFor="let group of push!.groups; let firstgr = first">
      <!-- Group title -->
      <div *ngIf="group.title" class="mb-2" [ngClass]="{'mt-8':!firstgr,'mt-4':firstgr}">
        <span class="text-theme-text font-bold text-xl">
          {{getString(group.title)}}
        </span>
      </div>

      <!-- Menu items -->
      <div class="flex flex-col gap-4">
        <div *ngFor="let item of group.menuItems; let lastit = last">
          <label class="flex items-start gap-3 w-full px-2 py-1 cursor-pointer">
            <div class="pt-1">
              <app-box-for-checkbox [ngModel]="selectedItems[item.id]"></app-box-for-checkbox>
            </div>
            <input type="checkbox"
                   [(ngModel)]="selectedItems[item.id]"
                   (change)="selectedChange(item)"
                   class="hidden">

            <app-push-item-content
              class="flex-1"
              [item]="item"
              [itemIncluded]="itemIncluded"
              [selectedItems]="selectedItems"
              [attrValues]="attrValues"
              [picked]="picked"
              (changePicks)="openPicks($event)">
            </app-push-item-content>

          </label>

        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="h-24">

  </div>
  <div class="mt-8 pb-4 fixed bottom-0 left-0 right-0 px-8 z-10">
    <app-action-button [text]="getString('Fortsätt')" (onClick)="continue()" [spinner]="isWorking" [disabled]="isWorking || itemSingleNotSelected"></app-action-button>
  </div>
</div>
